import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";
import { Grid } from '@material-ui/core';
import { GET } from "../../../queries/site";
import DrawerPlacements from '../../../components/DrawerPlacements';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';

import PageTitle from "../../../components/PageTitle/PageTitle";
import UpdateSites from '../../../pages/sites/actions/edit';
import AddSites from '../../../pages/sites/actions/create';
import Delete from '../../../pages/sites/actions/delete';

import { SettingsSite } from "../settings/actions/list";
import Scripts from "../components/Scripts";

const sitesFunc = ({ data: { sites, loading, error } }) => {

  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <Delete selectedRows={selectedRows} sites={sites} />
    )
  }

  const ActionsRow = (tableMeta) => {
    var id = tableMeta.rowData[1];
    var domain = tableMeta.rowData[0];
    var name = tableMeta.rowData[2];
    var services = tableMeta.rowData[4];
    var initial = tableMeta.rowData[5];
    var percentual = tableMeta.rowData[6];
    var publisherId = tableMeta.rowData[3];
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerPlacements title="Edit Sites" iconButtonAction={false} labeButtonAction={domain} showExternalLink={true}>
            <UpdateSites id={id} domain={domain} name={name} services={services} initial={initial} percentual={percentual}></UpdateSites>
          </DrawerPlacements>
        </Grid>
      </Grid>
    );
  };

  const actionsSite = (tableMeta) => {
    var id = tableMeta.rowData[1];
    var domain = tableMeta.rowData[0];
    var name = tableMeta.rowData[2];
    var publisherId = tableMeta.rowData[3];
    return (
      <>
        <SettingsSite id={id} name={name} domain={domain} publisherId={publisherId} />

        <Scripts publisherId={publisherId} />
      </>
    );
  };

  return (<>
    <Grid container spacing={0}>
      <Grid item xs={10}>
        <PageTitle title="Sites" />
      </Grid>
      <Grid item xs={2}>
        <DrawerPlacements title="Sites" labeButtonAction="Add">
          <AddSites></AddSites>
        </DrawerPlacements>
      </Grid>
    </Grid>
    {
      (loading) ? <PageLoading /> :
        (error) ? <PageError /> :
          (<Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={sites}
                columns={[{
                  name: "domain",
                  options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                      return (ActionsRow(tableMeta));
                    },
                    empty: true,
                    filter: true,
                    sort: true,
                  }
                }, {
                  name: "id",
                  options: {
                    display: false
                  }
                }, {
                  name: "name",
                  options: {
                    display: false
                  }
                }, {
                  name: "publisherId",
                  options: {
                    display: false
                  }
                }, {
                  name: "services",
                  options: {
                    display: false
                  }
                }, {
                  name: "initial",
                  options: {
                    display: false
                  }
                },
                {
                  name: "percentual",
                  options: {
                    display: false
                  }
                },
                {
                  label: 'Actions',
                  name: "actions",
                  options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                      return (actionsSite(tableMeta));
                    },
                    empty: true,
                    filter: false,
                    sort: false,
                  }
                }]}
                options={options}
              />
            </Grid>
          </Grid>)}

  </>);
}

export const Sites = graphql(GET)((sitesFunc));